import { type ComponentProps, memo } from 'react';

import { type Account, type ClipDiscussionResponse } from '@air/types';
import { cn } from '@air/utils-tailwind';

import {
  PlayerSeekbarTimestampsMarker,
  type PlayerSeekbarTimestampsMarkerProps,
} from './PlayerSeekbarTimestampsMarker';

export type Marker = {
  discussion: ClipDiscussionResponse;
  initials: string;
  timestamp: number;
  userAvatar?: string;
  userId: Account['id'];
};

export type PlayerSeekbarTimestampsProps = ComponentProps<'div'> &
  Pick<PlayerSeekbarTimestampsMarkerProps, 'onMarkerSelect'> & {
    getMarkerHighlight?: (marker: Marker) => boolean;
    markers: Marker[];
  };

export const PlayerSeekbarTimestamps = memo(
  ({ className, getMarkerHighlight, markers, onMarkerSelect, ...restOfProps }: PlayerSeekbarTimestampsProps) => {
    return (
      <div
        className={cn('pointer-events-none absolute inset-0 z-10', className)}
        data-testid="PLAYER_SEEKBAR_TIMESTAMPS"
        {...restOfProps}
      >
        {markers.map((marker) => (
          <PlayerSeekbarTimestampsMarker
            highlight={getMarkerHighlight?.(marker)}
            key={marker.discussion.id}
            marker={marker}
            onMarkerSelect={onMarkerSelect}
          />
        ))}
      </div>
    );
  },
);

PlayerSeekbarTimestamps.displayName = 'PlayerSeekbarTimestamps';
